var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 26"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "checked_with_circle_svg__a",
    d: "M13 .273C5.972.273.273 5.972.273 13c0 7.028 5.699 12.727 12.727 12.727 7.028 0 12.727-5.699 12.727-12.727C25.727 5.972 20.028.273 13 .273zm8.485 10.184l-10.05 9.614h-.805l-6.115-5.895v-.772l2.413-2.315h.804l3.302 3.168 7.207-6.914h.805l2.412 2.315c.027.302.027.496.027.799z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#checked_with_circle_svg__a"
  })));
}
export default SvgCheckedWithCircle;